import { TableCellProps } from "@mui/material";

export const makeCell = (name: string, align: TableCellProps["align"]) => ({
  name,
  align,
});
